export const replaceLocation = (url: string): void => {
    window.location.replace(url);
};

export const isInComparePage = (): boolean => window.location.href.includes('/compare');
